(function () {
  const LOCK = 'hypd-sc-open';

  function setLock(on) {
    document.documentElement.classList.toggle(LOCK, on);
  }

  function bind(drawer) {
    if (drawer.dataset.hypdScBound === 'true') return;
    drawer.dataset.hypdScBound = 'true';

    const sync = () => setLock(drawer.classList.contains('is-opened'));
    new MutationObserver(sync).observe(drawer, {
      attributes: true,
      attributeFilter: ['class']
    });
    sync();
  }

  function init() {
    document.querySelectorAll('.hypd-sc__drawer').forEach(bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
